import { formatDate } from "@angular/common";

export class TransactionResultData {
  public Errors: Array<ErrorListItem>;
  public ResponseData: TransactionSummaryData;
  public ResponseMessage: string;
  public ResponseStatus: boolean;
}

export class ErrorListItem {
  public ErrorCode: number;
  public ErrorMessage: string;
}

export class TransactionSummaryData {
  public RequestID: string;
  public Initiator: string;
  public MessageID: string;
  public RelatesToMessageID: string;
  public RelatesToRequestId: string;
  public MessageType: String;
  public PharmacyName: String;
  public PharmacyNCPDPID: String;
  public ResponseStatus: String;
  public IsPet: String;
  public Species: String;
  public PatientLastName: String;
  public PatientDOB: String;
  public RequestDate: String;
  public RequestData: string;
  public RequestJson: string;
  public PetEnabled: String;
  public ResponseData: Array<TransactionResponseData>;
  public ErrorData: Array<TransactionErrorData>;
}

export class TransactionResponseData{
  public PartDay: string;
  public ResponseId: string;
  public RequestId: string;
  public MessageId: string;
  public RelatesToMessageId: string;
  public MessageType: string;
  public IsPet: string;
  public ResponseStatus: string;
  public EndPoint: string;
  public ResponseData: string;
  public ResponseJson: string;
  public ResponseDate: string;
  public TransactionFrom: string;
  public TransactionTo: string;
}

export class TransactionErrorData {
  public RequestId: string;
  public ErrorCode: string;
  public ErrorMsg: string;
  public ErrorDate: string;
}

export class TransactionSummaryDataMapper {
    mapToModel(json: any): TransactionResultData {
      let transactionResultData:TransactionResultData=new TransactionResultData();
      return transactionResultData;
    }
}